export default function PHP_str_getcsv() {
  return (
    <div>
      <h1>PHP_str_getcsv</h1>
    </div>
  );
}
